import React from "react";
import { StatusBadge } from "./StatusBadge";

export function HistoryTimeline({ events }) {
  if (!events || events.length === 0) {
    return <p className="p-6 text-center text-sm text-muted-foreground">No history yet.</p>;
  }
  return (
    <ol className="relative ml-3 space-y-6 border-l border-slate-200 py-2">
      {events.map((e) => (
        <li key={e.id} className="relative pl-6">
          <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full bg-primary" />
          <div className="flex flex-wrap items-center gap-2">
            <p className="text-sm font-medium">{e.event}</p>
            {e.status && <StatusBadge status={e.status} />}
          </div>
          {e.details && <p className="mt-0.5 text-sm text-muted-foreground">{e.details}</p>}
          <p className="mt-0.5 text-xs text-muted-foreground">
            {new Date(e.created_at).toLocaleString()}
            {e.location ? ` · ${e.location}` : ""}
            {e.created_by_name ? ` · by ${e.created_by_name}` : ""}
          </p>
        </li>
      ))}
    </ol>
  );
}
